exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3vrkgbCDkzfLchwVbEfMn5 {\n  position: absolute;\n  padding: 3px 6px;\n  background-color: #091e42;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 0.9rem;\n  opacity: 0;\n  transition: opacity ease-in 0.1s;\n  pointer-events: none;\n}\n._3vrkgbCDkzfLchwVbEfMn5._17aSm379nzANjfKnp_bCpN {\n  transform: translate(-50%, 0);\n}\n._3vrkgbCDkzfLchwVbEfMn5._1o5HTZxw58bal9Nz6DccA1 {\n  opacity: 1;\n  z-index: 1000;\n}\n", ""]);

// Exports
exports.locals = {
	"tooltip": "_3vrkgbCDkzfLchwVbEfMn5",
	"alignCenter": "_17aSm379nzANjfKnp_bCpN",
	"visible": "_1o5HTZxw58bal9Nz6DccA1"
};